import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { asyncScheduler } from 'rxjs';

import { menuTransition } from './dropdown.transitions';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[dpwOverlay]',
  template: `
    <ng-content></ng-content>
  `,
  styleUrls: ['./styles/overlay.scss'],
  animations: [menuTransition],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverlayHostComponent {
  constructor(elementRef: ElementRef<HTMLElement>, renderer: Renderer2) {
    renderer.setStyle(elementRef.nativeElement, 'pointer-events', 'none');
    asyncScheduler.schedule(() => {
      renderer.setStyle(elementRef.nativeElement, 'pointer-events', '');
    }, 300);
  }
}
